import styled from "styled-components";

export const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 24px;

  .cancel-button-modal {
    width: 80px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #727577;
    margin: 0 2px;
    background-color: #9ea0a2;
    color: #000000;
    cursor: pointer;
    transition: 0.2s all;
  }

  .cancel-button-modal:hover {
    background-color: #75757a;
  }

  .accept-button-modal {
    width: 80px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #109565;
    margin: 0 2px;
    background-color: #41b68c;
    color: #f0f7ff;
    cursor: pointer;
    transition: 0.2s all;
  }

  .accept-button-modal:hover {
    background-color: #109565;
  }
`;
export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 14px 8px 0;
  background: var(--primary-800);
  border-radius: 8px;
  color: var(--primary-50);
  user-select: none;
  div {
    span {
      display: block;
      text-align: center;
      font-size: 16px;
      font-weight: 700;
      width: max-content;
      color: var(--primary-50);
    }
  }
  .sort {
    display: flex;
    cursor: pointer;
    width: fit-content;
    span {
      white-space: nowrap;
      &.active {
        /* text-shadow: 0px 0px 5px white; */
        font-size: 1.01rem;
      }
    }
    .pointers {
      margin-left: 8px;
      span {
        height: 3.99px;
        width: 8px;
        display: block;
        margin-bottom: -0.2rem;
        color: #f0f7ff;
        &.active {
          opacity: 1;
        }
      }
    }
  }
  .smallLabel {
    padding-right: 0.7rem;
    font-size: 0.7rem;
  }
  select {
    background-color: unset;
    border: unset;
    color: #fff;
    font-weight: bold;
    font-size: 1rem;
    border-radius: 10px;
    padding: 0.2rem 0;
    cursor: pointer;
    opacity: 0.9;
    border: none;
    outline: none;
    option {
      background-color: #3b608c;
      border-radius: 8px;
      border: none;
      outline: none;
    }
    &.active {
      opacity: 1;
    }
  }
`;

export const Tbody = styled.div`
  direction: ltr !important;
  color: #27548c;
  background-color: transparent;
  height: max-content;
  overflow-y: scroll;
  height: 320px;
  padding-right: 7px;
`;
export const TableRowCard = styled.div`
  display: flex;
  margin-top: 8px;
  direction: rtl;
  background-color: #fbfbff;
  border: 1px solid #e7e8f3;
  border-radius: 12px;
  padding: 11px 16px 11px 0;
  align-items: center;
  transition: 0.5s;
  cursor: pointer;
  position: relative;

  & > div:first-child {
    font-size: 18px;
  }
  &:hover {
    border: 1px solid var(--primary-300);
    background-color: #f4f7fc;
    & > div:nth-of-type(2) {
      color: #629ee8;
    }
  }
  & > div {
    font-weight: 700;
    font-size: 14px;
  }
  & > div:nth-of-type(3),
  & > div:nth-of-type(4) {
    font-weight: 500;
  }
`;

export const Paginate = styled.nav`
  display: flex;
  direction: rtl;
  align-items: center;
  justify-content: flex-start;
  margin-top: 6px;
  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: max-content;
    li {
      display: inline-block;
      margin: 0 8px;
      &:nth-of-type(1) {
        a {
          width: 52px;
          border-radius: 8px;
        }
      }
      &:last-child {
        a {
          width: 52px;
          border-radius: 8px;
        }
      }
      a {
        color: #27548c;
        width: 100%;
        width: 36px;
        height: 36px;
        font-size: 16px;
        font-weight: 400;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        & img.arrowPrev {
          padding-left: 9px;
        }
        & img.arrowNext {
          padding-right: 9px;
        }
      }
      a:hover {
        background-color: var(--primary-50);
      }
      a.active {
        background-color: var(--primary-100);
        border-radius: 8px;
      }
    }
  }
`;

export const DownloadWrapper = styled.div`
  display: flex;
  align-items: center;
  & img {
    margin-left: 11px;
  }
`;

export const DropDownContainer = styled.div`
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  @media (max-width: 1024px) {
    width: 150px;
  }
  @media (max-width: 360px) {
    width: 328px;
    margin-bottom: 20px;
  }
  & > div {
    display: flex;
    align-items: center;
  }
  & > div span {
    display: block;
    color: #f0f7ff;
    padding: 8px;
    font-size: 16px;
    font-weight: 700;
  }
  & > div svg {
    color: #f0f7ff;
    position: absolute;
    right: -8px;
    &.open {
      transform: rotate(180deg);
    }
  }
`;
export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: #27548c;
  position: absolute;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e9ebf8;
  right: -8px;
  left: 0;
  top: 41px;
  z-index: 100;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;

  & > option {
    width: 100%;
    padding: 8px;
    border-top: 1px solid #e9ebf8;
    &:last-child {
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      border-top: 1px solid #e9ebf8;
    }
    &:hover {
      background-color: #d1e6ff;
    }
  }
  &.hidden {
    display: none;
  }
`;
